/**
 * Read user-visible message from API errors. Ky `beforeError` merges JSON `{ detail }` onto the thrown error.
 */

function normalizeDetail(detail: unknown): string | undefined {
  if (typeof detail === "string" && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const parts = detail
      .map((x) => {
        if (typeof x === "string") return x;
        if (x && typeof x === "object" && "msg" in x) {
          const msg = (x as { msg?: unknown }).msg;
          return typeof msg === "string" ? msg : null;
        }
        return null;
      })
      .filter((x): x is string => Boolean(x));
    if (parts.length) return parts.join(" ");
  }
  else if (detail && typeof detail === "object" && "detail" in detail) {
    return normalizeDetail(detail.detail);
  }
  return undefined;
}

export const API_ERROR_CODE_MEETING_EXPIRED = "meeting_expired" as const;

function normalizeCode(value: unknown): string | undefined {
  if (value && typeof value === "object") {
    const record = value as Record<string, unknown>;
    if (typeof record.code === "string" && record.code.trim()) {
      return record.code.trim();
    }
    if (record.detail && typeof record.detail === "object") {
      return normalizeCode(record.detail);
    }
  }
  return undefined;
}

export function getApiErrorCode(error: unknown): string | undefined {
  return normalizeCode(error);
}

export function getApiErrorMessage(error: unknown): string {
  if (error && typeof error === "object") {
    const e = error as Record<string, unknown>;
    const fromDetail = normalizeDetail(e.detail);
    if (fromDetail) return fromDetail;
    if (typeof e.message === "string" && e.message.trim()) return e.message.trim();
  }
  if (error instanceof Error && error.message.trim()) return error.message;
  return "Something went wrong. Please try again.";
}
